"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressMatchFormats$ = exports.AddressMatchFormats$outboundSchema = exports.AddressMatchFormats$inboundSchema = exports.AddressMatchFormats = void 0;
const z = __importStar(require("zod"));
exports.AddressMatchFormats = {
    Default: "default",
    Planning: "planning",
    CouncilTax: "council_tax",
    Bridge: "bridge",
    Scores: "scores",
};
/** @internal */
exports.AddressMatchFormats$inboundSchema = z.nativeEnum(exports.AddressMatchFormats);
/** @internal */
exports.AddressMatchFormats$outboundSchema = exports.AddressMatchFormats$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AddressMatchFormats$;
(function (AddressMatchFormats$) {
    /** @deprecated use `AddressMatchFormats$inboundSchema` instead. */
    AddressMatchFormats$.inboundSchema = exports.AddressMatchFormats$inboundSchema;
    /** @deprecated use `AddressMatchFormats$outboundSchema` instead. */
    AddressMatchFormats$.outboundSchema = exports.AddressMatchFormats$outboundSchema;
})(AddressMatchFormats$ || (exports.AddressMatchFormats$ = AddressMatchFormats$ = {}));
//# sourceMappingURL=addressmatchformats.js.map